import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { Button } from "semantic-ui-react";
import PropTypes from "prop-types";
import { apirequest } from "./api-client";
import qs from "qs";

export const DownloadLink = (props) => {
  const [loading, setLoading] = useState(false);
  const requestRef = useRef(null);

  const urlWithoutPageParams = (url) => {
    const [base, paramStr] = url.split(/\?(.*)/);
    const params = qs.parse(paramStr);
    delete params.page;
    delete params.pageSize;
    return `${base}?${qs.stringify(params)}`;
  };

  const onClick = (event) => {
    event.preventDefault();
    setLoading(true);
    const req = apirequest("get", urlWithoutPageParams(props.href))
      .responseType("blob")
      .end((err, res) => {
        setLoading(false);
        requestRef.current = null;
        if (err) {
          if (props.onError) {
            const blob = res && res.body;
            if (blob instanceof Blob) {
              const reader = new FileReader();
              reader.onload = () => {
                try {
                  props.onError(JSON.parse(reader.result));
                } catch (_) {
                  props.onError({ status: res ? res.status : 500 });
                }
              };
              reader.readAsText(blob);
            } else {
              props.onError({ status: res ? res.status : 500 });
            }
          }
          return;
        }
        const _URL = window.URL || window.webkitURL;
        const url = _URL.createObjectURL(new Blob([res.body]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", props.download);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
    requestRef.current = req;
  };

  useEffect(() => {
    return () => {
      if (requestRef.current) {
        requestRef.current.abort();
      }
    };
  }, []);

  const { children, component, ...restProps } = props;
  return (
    <Button
      {...restProps}
      onClick={onClick}
      disabled={loading || restProps.disabled}
      loading={loading}
    >
      {children}
    </Button>
  );
};

DownloadLink.propTypes = {
  href: PropTypes.string.isRequired,
  download: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onError: PropTypes.func,
  children: PropTypes.node,
};
